import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Tabs({
    tabs,
    defaultTab = null,
    variant = 'default',
    className = ''
}) {
    const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

    const variants = {
        default: 'nav-tabs',
        pills: 'nav-pills',
        underline: 'nav-underline',
    };

    const activeTabData = tabs.find(t => t.id === activeTab);

    return (
        <div className={className}>
            <ul className={`nav ${variants[variant]} mb-3`}>
                {tabs.map((tab) => (
                    <li key={tab.id} className="nav-item">
                        <button
                            className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.icon && <i className={`bi ${tab.icon} me-2`}></i>}
                            {tab.label}
                            {tab.badge !== undefined && (
                                <span className="badge bg-primary-subtle text-primary ms-2">{tab.badge}</span>
                            )}
                        </button>
                    </li>
                ))}
            </ul>
            <AnimatePresence mode="wait">
                <motion.div
                    key={activeTab}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                >
                    {activeTabData?.content}
                </motion.div>
            </AnimatePresence>
        </div>
    );
}
